<template>
  <div class="export-success">
    <div class="export-success-content">
      <!-- <div class="export-success-content-header">
        <h3>导入结果</h3>
        <ds-iconfont
          class="close"
          icon-class="icon-ds-guanbi1"
          @click.native="close"
        />
      </div> -->
      <div class="export-success-content-con">
        <ds-iconfont
          class="icon"
          icon-class="icon-ds-chenggongtishi"
        />
        <span>导入成功</span>
      </div>
      <div class="handle">
        <mk-button-biz
          width="84px"
          height="32px"
          @click="continueClick"
        >
          继续导入
        </mk-button-biz>
        <mk-button-biz
          type="primary"
          width="84px"
          height="32px"
          @click="close"
        >
          导入完成
        </mk-button-biz>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    close () {
      this.$emit('close')
    },
    continueClick () {
      this.$emit('continue')
    }
  }
}
</script>
<style lang="scss" scoped>
  .export-success {
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.32);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;

    .export-success-content {
      width: 400px;
      border-radius: 4px;
      background-color: #fff;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      .export-success-content-header {
        width: 100%;
        height: 54px;
        box-sizing: border-box;
        border-bottom: 1px solid #e8e8e8;
        display: flex;
        align-items: center;
        justify-content: space-between;

        h3 {
          font-size: 14px;
          color: #262626;
          margin-left: 20px;
        }

        .close {
          font-size: 14px;
          color: #bfbfbf;
          margin-right: 20px;
          cursor: pointer;
        }
      }

      .export-success-content-con {
        display: flex;
        align-items: center;
        margin: 20px;

        .icon {
          color: #52c41a;
          font-size: 24px;
        }

        span {
          font-size: 16px;
          font-weight: 500;
          margin-left: 16px;
        }
      }

      .handle {
        display: flex;
        justify-content: flex-end;
        margin: 0 15px 15px 0;

        /deep/ .el-button {
          font-size: 13px;
        }
      }
    }
  }
</style>
